
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auctions",
      function () {
        return require("private-next-pages/auctions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auctions"])
      });
    }
  